import { inject, Injectable } from '@angular/core';
import { RightBridgeApiService } from '../services/right-bridge-api.service';

@Injectable({
  providedIn: 'root',
})
export class CashFlowPlannerServiceService {
  private rbs = inject(RightBridgeApiService);

  getCFPCalc(data) {
    this.rbs.setApp('aw');
    return this.rbs.postGroupProfile('CFPCalc', 'aw', data, false);
  }
}
